import React from "react";
import { Link } from "react-router-dom";
import MarketingShell from "./MarketingShell";
import Seo from "./Seo";
import HonorWall from "../components/HonorWall";
import { Heart, ArrowRight } from "lucide-react";

/**
 * Public-facing Quiet Wall — sistersignal.org/wall
 *
 * Reuses the same HonorWall component that lives inside the app's Donate
 * page (so seeded entries + real paid dedications all show in one place).
 * No amounts, no counts — just names and notes from people who gave.
 */
export default function WallPage() {
  return (
    <MarketingShell>
      <Seo
        title="The Quiet Wall"
        description="Held in honor — names and notes left by people who gave to Sister Signal. No amounts, no counts. Just memory."
        path="/wall"
      />

      <article className="max-w-5xl mx-auto px-6 sm:px-10 py-20" data-testid="page-wall">
        <p className="font-script text-2xl text-brand">held in honor</p>
        <h1 className="mt-2 font-serif text-5xl sm:text-6xl leading-tight">The Quiet Wall.</h1>
        <p className="mt-5 text-lg text-foreground/75 leading-relaxed max-w-2xl">
          Names and notes left by people who gave. No amounts. No counts. Just memory — for the women
          who didn&rsquo;t make it, the women still in it, and the women learning to call themselves
          home.
        </p>

        <div className="mt-12">
          <HonorWall />
        </div>

        {/* CTA — give & dedicate ----------------------------------------- */}
        <section className="mt-16 rounded-3xl bg-brand-soft/40 border border-brand/20 p-8" data-testid="wall-cta">
          <p className="font-script text-xl text-brand">add your own</p>
          <h2 className="mt-1 font-serif text-3xl leading-tight">A name, quietly, for someone who deserves it.</h2>
          <p className="mt-3 text-foreground/75 leading-relaxed">
            Donations of any size let you add to the wall. Names and notes are optional — your gift
            stays meaningful either way.
          </p>
          <Link
            to="/donate"
            data-testid="wall-give-cta"
            className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand text-white hover:bg-brand/90 transition-all"
          >
            <Heart className="w-4 h-4" /> Give & dedicate <ArrowRight className="w-4 h-4" />
          </Link>
        </section>
      </article>
    </MarketingShell>
  );
}
